import { initializeApp } from "firebase/app";
import { getAuth, GoogleAuthProvider, OAuthProvider } from "firebase/auth";
import { getMessaging } from "firebase/messaging";

const firebaseConfig = {
  apiKey: "AIzaSyCXdUd5QJY8mFpl6t1Jd326_Dc3-2YpnNw",
  authDomain: "engel-learning-app.firebaseapp.com",
  projectId: "engel-learning-app",
  storageBucket: "engel-learning-app.firebasestorage.app",
  messagingSenderId: "71802066708",
  appId: "1:71802066708:web:00026bfde67f9083c55401",
  measurementId: "G-SWHBH64W19"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const googleprovider = new GoogleAuthProvider();
googleprovider.setCustomParameters({
  prompt: "select_account",
});
const appleprovider = new OAuthProvider("apple.com");

let messaging;
if ("Notification" in window && navigator.serviceWorker) {
  messaging = getMessaging(app);
} else {
  console.warn("Push notifications not supported on this browser.");
}

export { auth, googleprovider, appleprovider, messaging };
